<rt-dialog-body layout-vertical>
  <div class="toolbar" layout-horizontal layout-space-between>
    <div class="heading-wrap" layout-vertical>
      <rt-heading variant="heading large-x" margin-bottom-small-x>{{
        attachment.filename
      }}</rt-heading>
      <rt-date variant="left-align" [time]="attachment.createdAt"> </rt-date>
    </div>
    <a
      rt-button
      [href]="
        !!attachment.originalFileUrl?.length ? attachment.originalFileUrl : attachment.fileUrl
      "
      [download]="newDownloadedFileName || ''"
      variant="tertiary"
    >
      <rt-icon name="file-download"></rt-icon>
      <span>{{ translations.downloadFile | translate }}</span>
    </a>
  </div>

  <div class="viewer-content" margin-tb-large layout-horizontal layout-justify-center>
    <div>
      @if (isImage) {
        <img class="image" [src]="attachment.imageUrl" />
      }
    </div>
    @if (isPdf) {
      <rt-pdf-viewer [assetUrl]="pdfUrl!"></rt-pdf-viewer>
    }
  </div>
</rt-dialog-body>
